<nk-company-person-search-box
  [attr.data-cy]="'top-menu-simple-search'"
  (simpleSearchEnterKeyPressOutput)="onSimpleSearchEnterKeyPress($event)"
  (searchSelectOutput)="onSimpleSearchSelect($event)"
  [clearOnSelect]="false"></nk-company-person-search-box>
